import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-surface border-t border-border-subtle" data-id="element-84">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16" data-id="element-85">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-16" data-id="element-86">
          {/* Col 1: Logo + Tagline */}
          <div data-id="element-87">
            <div className="mb-4" data-id="element-88">
              <img src="https://cdn.magicpatterns.com/uploads/j5oSMX1HPmmh812g8Nqn8c/reclutas_digitales_logo_dorado.png" alt="Reclutas Digitales" className="h-[84px] w-auto object-contain" data-id="element-89" />
            </div>
            <p className="text-sm text-[#b8b4ae] leading-relaxed max-w-xs" data-id="element-90">
              Incubadora de sistemas para agentes y agencias hispanas en EE.UU.
            </p>
            <p className="mt-4 text-xs text-[#7a7672] leading-relaxed max-w-xs" data-id="element-91">
              No garantizamos ingresos ni resultados específicos. Los resultados
              varían según mercado, producto y nivel de ejecución.
            </p>
          </div>

          {/* Col 2: Navigation */}
          <div data-id="element-92">
            <h3 className="text-xs font-semibold text-[#7a7672] uppercase tracking-widest mb-4" data-id="element-93">
              Navegación
            </h3>
            <ul className="space-y-2.5" data-id="element-94">
              <li data-id="element-95">
                <Link to="/agentes" className="text-sm text-[#b8b4ae] hover:text-cream transition-colors" data-id="element-96">
                  Agentes
                </Link>
              </li>
              <li data-id="element-97">
                <Link to="/duenos-de-agencia" className="text-sm text-[#b8b4ae] hover:text-cream transition-colors" data-id="element-98">
                  Dueños de Agencia
                </Link>
              </li>
              <li data-id="element-99">
                <Link to="/como-funciona" className="text-sm text-[#b8b4ae] hover:text-cream transition-colors" data-id="element-100">
                  Cómo Funciona
                </Link>
              </li>
              <li data-id="element-101">
                <Link to="/resultados" className="text-sm text-[#b8b4ae] hover:text-cream transition-colors" data-id="element-102">
                  Resultados
                </Link>
              </li>
              <li data-id="element-103">
                <Link to="/recursos" className="text-sm text-[#b8b4ae] hover:text-cream transition-colors" data-id="element-104">
                  Recursos
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Legal + CTA */}
          <div data-id="element-105">
            <h3 className="text-xs font-semibold text-[#7a7672] uppercase tracking-widest mb-4" data-id="element-106">
              Legal
            </h3>
            <ul className="space-y-2.5 mb-6" data-id="element-107">
              <li data-id="element-108">
                <Link to="/privacy" className="text-sm text-[#b8b4ae] hover:text-cream transition-colors" data-id="element-109">
                  Privacidad
                </Link>
              </li>
              <li data-id="element-110">
                <Link to="/terms" className="text-sm text-[#b8b4ae] hover:text-cream transition-colors" data-id="element-111">
                  Términos de Uso
                </Link>
              </li>
              <li data-id="element-112">
                <Link to="/disclaimer" className="text-sm text-[#b8b4ae] hover:text-cream transition-colors" data-id="element-113">
                  Disclaimer
                </Link>
              </li>
            </ul>
            <a href="/contact-us" className="inline-flex items-center px-4 py-2 bg-accent hover:bg-accent-hover text-charcoal font-semibold text-sm rounded-lg transition-colors" data-id="element-114">
              Agendar diagnóstico
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-border-subtle flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-115">
          <p className="text-xs text-[#7a7672]" data-id="element-116">
            © 2025 Reclutas Digitales. Todos los derechos reservados.
          </p>
          <p className="text-xs text-[#7a7672]" data-id="element-117">
            Hecho para agentes y agencias hispanas en EE.UU.
          </p>
        </div>
      </div>
    </footer>;
}